import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './_shared/PageHeader'
import ServiceOrdersLoader from './_load/ServiceOrderLoader'
import ChildrenServiceOrdersLoader from './_load/ChildrenServiceOrdersLoader'

const TemplateEpssoPdfPage = ({ templateId, id }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrdersLoader id={parseInt(id)}>
        <ChildrenServiceOrdersLoader id={parseInt(id)}>
          <PageHeader templateId={parseInt(templateId)} />
          <PageContent templateId={parseInt(templateId)} />
        </ChildrenServiceOrdersLoader>
      </ServiceOrdersLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateEpssoPdfPage
